import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { useLocation, useNavigate } from 'react-router-dom';

const BackButtonHandler = () => {
    const location = useLocation();
    const navigate = useNavigate()
    useEffect(() => {
        App.addListener("backButton", ({ canGoBack }) => {
            if (canGoBack) {
                navigate(-1);
            } else {
                App.exitApp();
            }
        });
    }, [navigate]);

    return null;
};

export default BackButtonHandler;
